module.exports = __webpack_public_path__ + "static/media/exo-latin-600.b84098a0.woff";